import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/pastDuePerformanceSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { paymentStatusOptions } from "../constants";

export const PaymentStatusFilter = () => {
  const dispatch = useDispatch();

  const selected = useSelector((state) => state.pastDuesPerformance.selectedFilters.paymentStatus);

  return (
    <div className="select-box-no-width">
      <p>Payment Status</p>
      <MultiSelectDropdown
        options={paymentStatusOptions}
        selectedFilters={selected}
        includeFilter={false}
        onSelectChange={(data) => dispatch(actionCreators.updatePaymentStatus(data))}
      />
    </div>
  );
};
